import { Scene } from "@babylonjs/core/scene";
import { SpriteHelper } from "./SpriteHelper";
import { Vector3 } from "@babylonjs/core";

export abstract class InteractionHelper {

  public static InitInteractions = (scene: Scene) => {

    // Sprite Picking
    scene.onPointerUp = (event) => {
      let spritePickResult = scene.pickSprite(scene.pointerX, scene.pointerY);
      if (spritePickResult?.hit) {
        let pickedSprite = spritePickResult.pickedSprite;
        if (pickedSprite) {
          SpriteHelper.GetHotspotByName(pickedSprite.name)?.clickFunction()
        }
      } else {
        let meshPickResult = scene.pick(scene.pointerX, scene.pointerY);
        if (meshPickResult.hit) {
          let pickedMesh = meshPickResult.pickedMesh;
          if (pickedMesh) {
            pickedMesh.physicsBody?.applyImpulse(Vector3.Up().multiplyByFloats(0, 2, 0), meshPickResult.pickedPoint as Vector3)
          }
        }
      }
    }

  }

}